import { styled, Button, ButtonProps, Box, BoxProps } from "@mui/material";

interface IBadContainerProps extends ButtonProps {
  top: number;
}

export const CustomButton = styled(Button)<ButtonProps>(({ theme }) => ({
  top: 255,
  right: 50,
  paddingLeft: "36px",
  paddingRight: "36px",
  position: "absolute",
}));

export const BadgeContainer = styled(Button)<IBadContainerProps>(({ top }) => ({
  right: 40,
  top: `${top}px`,
  display: "flex",
  flexDirection: "row",
  position: "absolute",
}));

export const BadgeText = styled(Box)<BoxProps>({
  marginRight: "20px",
  paddingTop: "10px",
  paddingBottom: "10px",
  paddingLeft: "20px",
  paddingRight: "20px",
  background: "#FFF",
  color: "#000",
  borderRadius: "8px",
});

export const BadgeIconContainer = styled(Box)<BoxProps>({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  background: "#46A0CD",
  width: 45,
  height: 45,
  borderRadius: 100,
});
